import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
const LANG_ENGLISH_ISO = "en";
const COUNTRY_GREAT_BRITAIN_ISO = "gb";
const COUNTRY_US_ISO = "us";
export class FlagComponent {
    set language(lang) {
        if (lang)
            this.flag = lang === LANG_ENGLISH_ISO ? COUNTRY_GREAT_BRITAIN_ISO : lang; // mapping needed since en is no valid country iso, hence we use gb instead to display the flag.
    }
    set country(country) {
        if (country)
            this.flag = country;
    }
    set locale(locale) {
        if (locale) {
            const [lang, country] = locale.split("_");
            if (lang === "en" && country === "us")
                this.country = COUNTRY_US_ISO;
            else
                this.language = lang;
            if (country !== "us" && lang !== country)
                this.secondFlag = country;
            else
                this.secondFlag = undefined;
        }
    }
}
FlagComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.5", ngImport: i0, type: FlagComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
FlagComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.5", type: FlagComponent, selector: "smallstack-flag", inputs: { language: "language", country: "country", locale: "locale" }, ngImport: i0, template: "<span *ngIf=\"flag\" class=\"flag-icon flag-icon-{{ flag }}\">\n  <span *ngIf=\"secondFlag\" class=\"flag-icon flag-icon-{{ secondFlag }} flag-second\"></span>\n</span>\n", styles: [".flag-second{position:absolute;left:4px;top:4px;z-index:15;width:10px}.flag-icon{position:relative}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.5", ngImport: i0, type: FlagComponent, decorators: [{
            type: Component,
            args: [{ selector: "smallstack-flag", changeDetection: ChangeDetectionStrategy.OnPush, template: "<span *ngIf=\"flag\" class=\"flag-icon flag-icon-{{ flag }}\">\n  <span *ngIf=\"secondFlag\" class=\"flag-icon flag-icon-{{ secondFlag }} flag-second\"></span>\n</span>\n", styles: [".flag-second{position:absolute;left:4px;top:4px;z-index:15;width:10px}.flag-icon{position:relative}\n"] }]
        }], propDecorators: { language: [{
                type: Input
            }], country: [{
                type: Input
            }], locale: [{
                type: Input
            }] } });
